import {params, provider} from './state';

/**
 * Establecer un valor para la variable providers.
 */
export function setProviders(state, providers) {
    state.providers = providers;
}

/**
 * Establecer un valor para la variable identification_types.
 */
export function setIdentificationTypes(state, identification_types) {
    state.identification_types = identification_types;
}

/**
 * Establecer un valor para la variable provider.
 */
export function setProvider(state, provider) {
    state.provider = provider;
}

/**
 * Establecer un valor para la variable provider.
 */
export function resetProvider(state) {
    state.provider = provider();
}

/**
 * Mutación para limpiar el buscador de proveedores.
 */
export function resetParams(state) {
    state.params = params();
}

/**
 * Establecer un valor para el atributo page de la variable params.
 */
export function setPageToParams(state, page) {
    state.params.page = page;
}

/**
 * Establecer un valor para el atributo company_id de la variable params.
 */
export function setCompanyIdToParams(state, company_id) {
    state.params.company_id = company_id;
}
